

export default (function (className, styles) {
  if (!styles[className]) {
    throw new Error('Could not resolve the styleName ' + className);
  }

  return styles[className];
});


//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/react-flag-icon-css/module/functions/classNameToStyleName.js
// module id = 694
// module chunks = 0